import { Tooltip, TooltipProps } from "antd";
import classNames from "classnames";
import { ReactNode } from "react";
import styles from "./style.module.scss";

interface VLTooltipProps extends Omit<TooltipProps, "children"> {
  children: ReactNode;
  className?: string;
  fitContent?: boolean;
  forceHide?: boolean;
}

const VLTooltip = ({
  children,
  className,
  fitContent,
  forceHide,
  open,
  ...rest
}: VLTooltipProps) => {
  const classNameWrapper = classNames(className, {
    [styles.fitContent]: !!fitContent,
  });
  const tooltipProps: TooltipProps = {
    ...rest,
    open: forceHide ? false : open,
    ...(classNameWrapper && { overlayClassName: classNameWrapper }),
  };

  return <Tooltip {...tooltipProps}>{children}</Tooltip>;
};

export default VLTooltip;
